import type { IxfReportsV1ReportKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../util/routing/entity-paths';

export const REPORT_BASE_PATH = getResolvedPath('/clearing/operations/reporting/archive');

export const getReportPath: EntityPathBuilder<IxfReportsV1ReportKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return REPORT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.reportId) {
        return undefined;
      }

      return getResolvedPath(`${REPORT_BASE_PATH}/$reportId`, context.keys);
    }
  }
};

export function getReportDetailPath(reportId: string | undefined) {
  if (!reportId) {
    return undefined;
  }

  return getReportPath({ kind: 'detail', keys: { reportId } });
}
